export default "__VITE_ASSET__yaEHzJng__"